<template>
  <div class="page">
    <a-modal :title="title" :visible="visible" @ok="newHandleOk" @cancel="offPop">
      <a-form-model :model="form" :label-col="labelCol" class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-form-model-item label="导出空位：">
            <a-radio-group name="radioGroup" :default-value="1">
              <a-radio
                @change="valChange"
                :value="index + 1"
                v-for="(item, index) in form.unit"
                :key="index"
              >
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="选择城市：">
            <a-col :span="16">
              <a-tree-select
                v-model="value"
                :tree-data="treeData"
                :load-data="onLoadData"
                tree-checkable
                @change="changeSelect"
                @select="selectTree"
                search-placeholder="请选择城市"
                tree-data-simple-mode
                treeNodeFilterProp="title"
                :show-checked-strategy="SHOW_PARENT"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              />
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="投放日期：">
            <a-col :span="16">
              <a-range-picker
                class="release-time"
                :defaultValue="[moment(startTime, dateFormat), moment(endTime, dateFormat)]"
                :format="dateFormat"
                @change="dateChange"
                @calendarChange="calendarChange"
                @openChange="openChange"
                :disabledDate="disabledDate"
              >
              </a-range-picker>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="展现机制：">
            <a-col :span="16">
              <a-radio-group name="radioGroup" :default-value="1">
                <a-radio
                  @change="mechanismChange"
                  :value="index + 1"
                  v-for="(item, index) in form.mechanism"
                  :key="index"
                >
                  {{ item.name }}
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="广告位置：">
            <a-col :span="16">
              <a-radio-group name="radioGroup" :value="param.spaceId">
                <a-radio
                  @change="StyleChange"
                  :style="radioStyle"
                  :value="item.val"
                  v-for="(item, index) in form.advertising"
                  :key="index"
                >
                  {{ item.name }}
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24" v-show="param.priceStrategy != 2">
          <a-form-model-item label="播放时段">
            <a-col :span="8">
              <a-select
                v-if="positionId === 1"
                :default-value="notLocal ? '3' : '2'"
                style="width: 120px"
                @change="selectDeliveryPeriod"
              >
                <a-select-option value="3" v-if="notLocal">
                  24小时霸屏
                </a-select-option>
                <a-select-option value="2">
                  黄金时段
                </a-select-option>
                <a-select-option value="1">
                  普通时段
                </a-select-option>
              </a-select>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="素材时长：">
            <a-col :span="8">
              <a-select
                :disabled="piontsSecond.length > 0 ? false : true"
                :value="String(playSecond)"
                @change="selectPoints"
                style="width: 120px"
              >
                <a-select-option v-for="item in piontsSecond" :key="item" :value="item">{{
                  item + '秒'
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24" v-show="param.priceStrategy != 2">
          <a-form-model-item label="播放次数：">
            <a-col :span="8">
              <a-select
                v-if="positionId === 1"
                :value="String(playCounts)"
                style="width: 120px"
                @change="selectCounts"
              >
                <a-select-option v-for="val in playCountData[playSecond]" :value="val" :key="val">{{
                  val + '次'
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-form-model-item>
        </a-row>

        <a-row :gutter="24">
          <a-form-model-item label="连续在线：">
            <a-col :span="8">
              <a-select :value="String(thisDate)" style="width: 120px" @change="selectDate">
                <a-select-option v-for="val in daysNumber" :value="val" :key="val">{{
                  val == '0' ? '不限' : '大于' + val + '天'
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { baseURL } from '../../../utils/config'
import api from '../../../commomFun/api.js'
import { pointsRules } from '../../../utils/config.js'
import $ from 'jquery'
import moment from 'moment'
import { TreeSelect } from 'ant-design-vue'
import { getDeliveryPeriodConfig } from '../../../commomFun/deliveryPeriodConfig'
const SHOW_PARENT = TreeSelect.SHOW_PARENT
export default {
  props: {
    // 弹窗标题名字
    title: {
      type: String,
      default: () => ''
    },
    // 弹窗显隐
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      treeData: [],
      SHOW_PARENT,
      TreeSelect,
      value: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      //ui渲染使用数据
      form: {
        unit: [{ name: '网点' }, { name: '点位' }],
        city: [],
        startTime: [],
        mechanism: [{ name: '轮播' }, { name: '触发' }],
        advertising: [{ name: '大屏轮播广告', val: 1 }],
        time: [{ name: '15s' }, { name: '25s' }, { name: '35s' }, { name: '45s' }],
        HowMany: [{ name: '300次/天' }, { name: '400次/天' }, { name: '500次/天' }]
      },
      daysNumber: ['0', '3', '7', '15', '30'],
      param: {
        vacancyType: 1, //空位类型 1：网点(默认) 2：点位
        beginTime: '',
        endTime: '',
        playDuration: 0, //播放时长
        playTimes: 0, //播放次数
        priceStrategy: 1, //展现机制
        spaceId: 1, //广告位置
        satisfyPortion: true,
        date: 0, //在线时长不限
        deliveryPeriod: 3 //播放时段默认24小时霸屏
      },
      province: [], //省份
      city: [], //城市
      companyId: '', //公司id代替token
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      moment,
      startTime: '',
      endTime: '',
      dateFormat: 'YYYY/MM/DD',
      pointsRules: {},
      piontsSecond: [],
      playSecond: 10,
      playCounts: 300,
      thisDate: '不限',
      startDate: '',
      endDate: '',
      dateArr: [],
      weekDay: 6,
      counts: 1,
      isSuperVip: false,
      nextSaturday: '',
      nextFriday: '',
      needStartTime: '',
      positionId: 1,
      newTreeData: [],
      sonArr: [],
      selectArr: [],
      userType: '', // 角色类别 1.超级管理员  2。地方销售  3.ep 工程人员  4.地方媒介 5.全国媒介 6. 公司管理员 7全国销售
      notLocal: '', //是否是当地销售/媒体 不是为true 是的话为false
      playCountData: {}, //增加24小时霸屏模式，原来的播放次数不能达到要求，这里再取一个值
      deliveryPeriodConfig: {
        allDayPointsRules: {}, //24小时霸屏
        allDayTimes: [], //24小时霸屏
        goldPointsRules: {}, // 黄金时段 次数
        goldTimes: [], // 黄金时段 时间秒数
        commonPointsRules: {}, //普通时段
        commonTimes: [] //普通时段  现在是后端拿数据不需要前端判断属否是地方还是全国
      }
    }
  },
  created() {
    //树结构只有两层自定义
    let that = this

    //根据名字判断是不是超级管理员 不是根据用户类别
    const { userName, userType } = sessionStorage.getItem('userInfo')
      ? JSON.parse(sessionStorage.getItem('userInfo'))
      : sessionStorage.getItem('userInfo')
    if (userName === 'qadx_sale' || userName === 'dfmj2' || userName === 'xs0821') {
      this.isSuperVip = true
    } else {
      this.isSuperVip = false
    }
    this.userType = userType //得到用户类别 打个分号防止把userType当函数执行报错
    getDeliveryPeriodConfig().then(data => {
      this.deliveryPeriodConfig = data
      that.getPointRules() //防止异步问题，初始化放在获得数据之后
      that.defaultSelectDate() //初始化时间、
      //避免异步将初始化放进来
      //设置请求this.param.deliveryPeriod默认值
      //超级管理员没有点位，防止报错
      try {
        this.notLocal = that.userType == 5 || that.userType == 7
        if (this.notLocal) {
          this.param.deliveryPeriod = 3
          this.piontsSecond = that.deliveryPeriodConfig.allDayTimes
          that.playCountData = that.deliveryPeriodConfig.allDayPointsRules
          that.playCounts = that.deliveryPeriodConfig.allDayPointsRules['10'][0]
        } else {
          that.param.deliveryPeriod = 2
          that.piontsSecond = that.deliveryPeriodConfig.goldTimes
          that.playCountData = that.deliveryPeriodConfig.goldPointsRules
          that.playSecond = '10'
          that.playCounts = that.deliveryPeriodConfig.goldPointsRules['10'][0]
        }

        let info = that.publicData(0) // 根据传参0:查省 1:市 2:区 获取请求不同的参数
        api.postApiSpecil('/platform/api/v1/common/area/getArea', info).then(res => {
          let data = res.data.data
          data.forEach((item, index) => {
            // 将数据处理展示需要的格式
            that.treeData.push({
              title: item.areaName,
              value: item.areaCode,
              id: item.areaCode
            })
          })
          that.newTreeData = that.treeData
        })

        //初始化赋值
        let init = this.param
        init.playDuration = Number(this.piontsSecond[0]) //得到素材时列表中的第一位为默认值 为什么select框需要用2个变量来做？不是有默认的属性吗
        init.playTimes = Number(this.playCountData[init.playDuration][0]) //得到播放次数列表 默认为第一项
        init.beginTime = moment(this.startDate).format('YYYY-MM-DD')
        init.endTime = moment(this.endTime).format('YYYY-MM-DD')
      } catch (error) {}
    })

    //发送请求获得城市信息 /
  },
  mounted() {},

  methods: {
    //设置不可选的时间
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day')
    },
    changeSelect(v, n) {
      this.selectArr = v
    },
    //选中几天
    selectDate(v) {
      this.thisDate = v * 1
    },
    selectTree(v, n) {
      this.sonArr.push(n.dataRef)
    },
    onLoadData(v) {
      return new Promise(resolve => {
        let [arr, index, that, key, value, id, f] = [[], 0, this, 0, 0, {}, []]
        arr = this.treeData.map(item => {
          return item.value
        })
        id = v.dataRef.value
        f.push(id)
        value = v.value
        index = arr.indexOf(value)
        key = that.treeData[index].key
        // that.treeData[index].children = [];
        let info = this.publicData(1)
        info.areaCode = []
        info.areaCode.push(value)
        api.postApiSpecil('/platform/api/v1/common/area/getArea', info).then(res => {
          console.log(res.data.data, 'res.data.data')
          res.data.data.map((item, index) => {
            if (item) {
              that.treeData = that.treeData.concat([
                that.genTreeNode(value, item.areaCode, item.areaName)
              ])
            }
          })
          resolve()
        })
      })
    },
    genTreeNode(parentId, value, title) {
      return {
        id: value,
        pId: parentId,
        value: value,
        title: title,
        isLeaf: true
      }
    },
    //广告位置
    StyleChange(v) {
      this.param.spaceId = v.target.value
      switch (v.target.value) {
        case 1:
          this.piontsSecond = ['10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60']
          this.playSecond = '10'
          break
        case 2:
          this.piontsSecond = ['10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60']
          this.playSecond = '10'
          break
        case 3:
          this.piontsSecond = ['5', '10', '15']
          this.playSecond = '5'
          this.playCountData = this.piontsSecond

          break
        case 4:
          this.piontsSecond = []
          this.playSecond = '不限制'
          this.playCountData = this.piontsSecond

          break
        case 5:
          this.piontsSecond = ['5', '10', '15']
          this.playSecond = '5'
          this.playCountData = this.piontsSecond
          break
      }
      console.log(this.param.spaceId)
    },
    //选择触发机制
    mechanismChange(v) {
      this.form.advertising = []
      this.param.priceStrategy = v.target.value
      if (v.target.value == 2) {
        this.form.advertising.push(
          { name: '大屏人脸识别精准广告', val: 2 },
          { name: '开门成功精准弹窗广告', val: 3 },
          { name: '对讲通话广告', val: 4 },
          { name: '开门成功弹窗广告', val: 5 }
        )
        this.param.spaceId = 2
        this.playCountData = this.pointsRules
        this.piontsSecond = ['10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60']
        this.playSecond = '10'
      } else {
        this.form.advertising.push({ name: '大屏轮播广告', val: 1 })
        this.param.spaceId = 1
        //判断 播放时段 来设置给播放次数
        if (this.param.deliveryPeriod == 1) {
          //普通时段
          this.playCountData = this.deliveryPeriodConfig.commonPointsRules
          this.piontsSecond = this.deliveryPeriodConfig.commonTimes
        } else if (this.param.deliveryPeriod == 2) {
          // 黄金时段
          this.playCountData = this.deliveryPeriodConfig.goldPointsRules
          this.piontsSecond = this.deliveryPeriodConfig.goldTimes
        } else if (this.param.deliveryPeriod == 3) {
          //24小时霸屏
          this.playCountData = this.deliveryPeriodConfig.allDayPointsRules
          this.piontsSecond = this.deliveryPeriodConfig.allDayTimes
          this.playCounts = this.deliveryPeriodConfig.allDayPointsRules['10']
        }
      }
      this.playSecond = '10'
    },
    //导出空位的选择
    valChange(v) {
      this.param.vacancyType = v.target.value
    },
    //被关闭的弹窗
    offPop() {
      this.$emit('afterClose', false)
    },
    //弹窗点击确定
    newHandleOk() {
      let that = this
      if (that.value == '') {
        return that.$message.error('请选择城市！')
      }
      this.companyId = sessionStorage.getItem('asrId')
      that.province = that.value
      let param = this.param
      if (param.priceStrategy == 2) {
        param.playTimes = ''
      } else {
        if (!param.playTimes) {
          param.playTimes = that.playCountData[that.playSecond][0]
        }
      }
      param.playDuration = this.playSecond == '不限制' ? 0 : this.playSecond
      this.thisDate == '不限' ? (this.thisDate = 0) : this.thisDate
      param.onlineDayNum = this.thisDate
      param.companyId = this.companyId
      param.area = '[' + this.selectArr.join(',') + ']'
      // let res = '';
      // const url = Object.keys(param);
      // url.forEach((key) => {
      //   res += '&' + key + '=' + param[key];
      // });
      // res = res.substr(1);
      // window.location.href =
      //   baseURL + '/platform/api/v1/exportVacancy/exportVacancyData?' + res;
      api.getApi_file('/exportVacancy/exportVacancyData', param).then(res => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        let downloadElement = document.createElement('a')
        let href = window.URL.createObjectURL(blob) //创建下载的链接
        downloadElement.href = href
        downloadElement.download = decodeURIComponent(res.headers['content-disposition']).split(
          '='
        )[1] //下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() //点击下载
        document.body.removeChild(downloadElement) //下载完成移除元素
        window.URL.revokeObjectURL(href) //释放掉blob对象
      })
      this.$emit('newHandleOk', false)
      this.sonArr = []
      this.value = []
    },
    //两次请求公用的参数
    publicData(type) {
      let that = this
      let info = {
        beginTime: moment(that.startDate).format('YYYY/MM/DD'),
        endTime: moment(that.endDate).format('YYYY/MM/DD'),
        playDuration: that.piontsSecond[0],
        playTimes: that.playCountData[that.playSecond][0],
        selectType: type // 0:查省 1:市 2:区
      }
      return info
    },
    // 祖传代码
    getCurrentStyle(current) {
      const style = {}
      if (current.day() !== this.weekDay) {
        style.position = 'relative'
        style.top = '0'
        style.left = '0'
        style.height = '100%'
        style.width = '100%'
        style.background = '#f5f5f5'
        style.pointerEvents = 'none'
      } else {
        style.background = ''
      }
      return style
    },
    //渲染样式让不可选的日期变灰色
    getCurrentClass(current) {
      let status = false
      this.timeout = setTimeout(() => {
        if (this.counts > 1) {
          clearTimeout(this.timeout)
        }
        this.counts++
        $('.datechange')
          .parent()
          .addClass('ant-calendar-disabled-cell')
          .css({
            pointerEvents: 'none'
          })
        //ant-calendar-cell ant-calendar-disabled-cell-last-of-row
        // 上刊时间为周六，下刊为周五，按周投放，投放时间周五之前能选本周六，到了周五只能至少选下周六
        //2021.5.21 修改 上刊时间为周日，下刊为周六，按周投放，投放时间周六之前能选本周日，到了周六只能至少选下周日
        $('.datenochage')
          .parent()
          .removeClass('ant-calendar-disabled-cell')
          .removeClass('ant-calendar-disabled-cell-last-of-row')
          .css({
            pointerEvents: 'auto'
          })
          .each((idx, item) => {
            let startTime =
              moment(this.weekDay === 5 ? this.nextFriday : this.nextSaturday).format(
                'YYYY-MM-DD'
              ) + ' 00:00:00'
            startTime = moment(startTime).valueOf()
            const yearId = item.title.indexOf('年')
            const monthId = item.title.indexOf('月')
            const dayId = item.title.indexOf('日')
            let date = item.title.split('')
            date[yearId] = '-'
            date[monthId] = '-'
            date[dayId] = ''
            let parentDate = date.join('')
            const parentTime = new Date(parentDate).getTime()

            if (startTime > parentTime) {
              $(item)
                .addClass('ant-calendar-disabled-cell')
                .css({
                  pointerEvents: 'none'
                })
            }
          })
      }, 0)
      if (current.day() !== this.weekDay) {
        return 'ant-calendar-date ant-calendar-disabled-cell datechange'
      }
      return 'ant-calendar-date datenochage'
    },
    openChange(status) {
      $('.ant-input').css({ borderColor: '#d9d9d9' })
      setTimeout(() => $('.ant-calendar-input').css({ pointerEvents: 'none' }), 100)
      if (status) {
        this.weekDay = 6
      }
    },
    checkDate() {
      const formItem = JSON.parse(sessionStorage.getItem('formItem'))
      const beginTime = moment(formItem.beginTime).format('YYYY-MM-DD') + ' 00:00:00'
      //判断选择时间是否大于等于今天，缓存时间可能是过去时间
      const today = moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
      if (today > beginTime) {
        $('.ant-input').css({ borderColor: '#f5222d' })
        this.$message.warning('请重新选择投放时间')
        return true
      } else {
        $('.ant-input').css({ borderColor: '#d9d9d9' })
        this.dateErrStatus = false
        // callback()
      }
      //关闭周六的校验
      // if (this.isSuperVip) return false
      // const needStartTime =
      //   moment(this.needStartTime).format('YYYY-MM-DD') + ' 00:00:00'
      // //判断下周六的时间是否大于开始时间
      // if (new Date(needStartTime).getTime() > new Date(beginTime).getTime()) {
      //   $('.ant-input').css({ borderColor: '#f5222d' })
      //   this.$message.warning('请重新选择投放时间')
      //   return true
      // } else {
      //   $('.ant-input').css({ borderColor: '#d9d9d9' })
      //   this.dateErrStatus = false
      //   // callback()
      // }
      return false
    },
    calendarChange(current) {
      const dateArr = [...current]
      if (dateArr.length > 0) {
        this.weekDay = 5
        let date = new Date(moment(dateArr[0].format('YYYY/MM/DD HH:mm:ss')))
        date.setDate(date.getDate() + 6)
        this.nextFriday = date
      }
      this.counts = 0
    },
    dateChange(val) {
      this.param.beginTime = moment(val[0]).format('YYYY-MM-DD')
      this.param.endTime = moment(val[1]).format('YYYY-MM-DD')
    },
    //素材时常
    selectPoints(val) {
      this.param.playDuration = Number(val)
      this.playSecond = Number(val)
      if (this.param.deliveryPeriod == 2) {
        this.playCounts = this.deliveryPeriodConfig.goldPointsRules[val][0]
      } else if (this.param.deliveryPeriod == 1) {
        this.playCounts = this.deliveryPeriodConfig.commonPointsRules[val][0]
      } else if (this.param.deliveryPeriod == 3) {
        this.playCounts = this.deliveryPeriodConfig.allDayPointsRules[val][0]
      }
    },
    //选择播放时段
    selectDeliveryPeriod(val) {
      this.param.deliveryPeriod = Number(val)
      switch (Number(val)) {
        //普通时段
        case 1:
          //是否是全国媒介或者是全国销售
          this.piontsSecond = this.deliveryPeriodConfig.commonTimes
          this.playSecond = '10'
          this.playCountData = this.deliveryPeriodConfig.commonPointsRules
          this.playCounts = this.deliveryPeriodConfig.commonPointsRules['10'][0]
          break
        // 黄金时段
        case 2:
          this.piontsSecond = this.deliveryPeriodConfig.goldTimes
          this.playSecond = '10'
          this.playCountData = this.deliveryPeriodConfig.goldPointsRules
          this.playCounts = this.deliveryPeriodConfig.goldPointsRules['10'][0]
          break
        // 24小时霸屏
        case 3:
          this.piontsSecond = this.deliveryPeriodConfig.allDayTimes
          this.playSecond = '10'
          this.playCountData = this.deliveryPeriodConfig.allDayPointsRules
          this.playCounts = this.deliveryPeriodConfig.allDayPointsRules['10'][0]
          break
        default:
          break
      }
      this.param.playTimes = Number(this.playCounts)
    },
    //播放次数
    selectCounts(val) {
      this.param.playTimes = Number(val)
      this.playCounts = Number(val)
    },

    // 初始化时间
    defaultSelectDate() {
      const todayDate = new Date()
      const day = todayDate.getDay()
      const days = Math.abs(6 - day)
      let startTime = todayDate
      if (day > 4) {
        startTime.setDate(todayDate.getDate() + days + 7)
      } else {
        startTime.setDate(todayDate.getDate() + days)
      }
      this.startTime = startTime
      this.needStartTime = startTime
      this.nextSaturday = startTime
      const endTime = new Date(startTime)
      endTime.setDate(todayDate.getDate() + 6)
      this.nextFriday = this.endTime
      this.endTime = endTime
      this.startDate = this.startTime //这是什么操作
      this.endDate = this.endTime
    },
    //配置素材时常对应的播放次数选项  21.5.22日24小时霸屏需求 每个秒数对应的就一个次数
    getPointRules() {
      const pointsObj = this.pointsRules
      const piontsSecond = this.piontsSecond
      if (this.positionId == 4 || this.positionId == 5) {
        pointsRules['5'] = ''
      } else {
        delete pointsRules['5']
      }
      for (let key in pointsRules) {
        const itemArr = pointsRules[key].split(',')
        piontsSecond.push(key)
        pointsObj[key] = itemArr
      }
      this.playCounts = pointsObj[this.playSecond][0]
      this.pointsRules = pointsObj
    }
  }
}
</script>

<style scoped></style>
